import { render, staticRenderFns } from "./AppItem.vue?vue&type=template&id=429da85a&scoped=true&"
import script from "./AppItem.vue?vue&type=script&lang=js&"
export * from "./AppItem.vue?vue&type=script&lang=js&"
import style0 from "./AppItem.vue?vue&type=style&index=0&id=429da85a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "429da85a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/admin/Docker/server/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('429da85a')) {
      api.createRecord('429da85a', component.options)
    } else {
      api.reload('429da85a', component.options)
    }
    module.hot.accept("./AppItem.vue?vue&type=template&id=429da85a&scoped=true&", function () {
      api.rerender('429da85a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "apps/settings/src/components/AppList/AppItem.vue"
export default component.exports